/**
 * Date + typeable-time field that emits the SAME string shape as a native
 * <input type="datetime-local"> ("YYYY-MM-DDTHH:MM"), so it can drop in
 * wherever that control was used. The time half uses the friendly, typeable
 * TimeSelect instead of the clunky native clock.
 */
import React from 'react';
import { Input } from '@/components/ui/input';
import { TimeSelect } from '@/components/common/TimeSelect';

function split(value) {
  if (!value || !value.includes('T')) return { date: value || '', time: '' };
  const [d, t] = value.split('T');
  return { date: d || '', time: (t || '').slice(0, 5) };
}

export function DateTimeField({
  value, onChange, disabled = false, testId, dateClassName = '', timeClassName = '',
  min,
}) {
  const { date, time: valueTime } = split(value);
  // Remember a time picked before a date so it isn't thrown away.
  const [pendingTime, setPendingTime] = React.useState('');
  const time = valueTime || (!date ? pendingTime : '');

  const emit = (nextDate, nextTime) => {
    if (!nextDate) { setPendingTime(nextTime || ''); onChange(''); return; }
    onChange(`${nextDate}T${nextTime || pendingTime || '09:00'}`);
  };

  return (
    <div className="grid grid-cols-[1.3fr_1fr] gap-2">
      <Input
        type="date"
        value={date}
        disabled={disabled}
        min={min}
        data-testid={testId ? `${testId}-date` : undefined}
        className={dateClassName}
        onChange={(e) => emit(e.target.value, time)}
      />
      <TimeSelect
        value={time}
        disabled={disabled}
        testId={testId ? `${testId}-time` : undefined}
        className={timeClassName}
        onChange={(t) => emit(date, t)}
      />
    </div>
  );
}

export default DateTimeField;
